import type { ModuleGate } from '@/shell/model/module-catalog';

/** The Director only (spec §5.2): the screens of «Comunicazioni» and nothing else need it. */
export const COMMUNICATIONS_APPROVE = 'communications:approve';

/** One rule, read by the rail entry and the route gate. Convenience only: the API re-checks. */
export const COMMUNICATIONS_GATE: ModuleGate = {
  kind: 'permission',
  anyOf: [COMMUNICATIONS_APPROVE],
};
